import React, { useState, useEffect } from "react";
import {
  Row,
  Col,
  Card,
  Typography,
  Button,
  message,
  Divider,
  Table,
  Input,
  Tooltip,
  Form,
  Modal,
  Select,
  Space,
} from "antd";
import {
  EditOutlined,
  SearchOutlined,
  PlusOutlined,
  DeleteOutlined,
  UnorderedListOutlined,
  OrderedListOutlined,
  CloseCircleOutlined,
  CheckCircleOutlined,
} from "@ant-design/icons";
import { HeaderPage } from "../../../components/headerPage";
import { HeaderTitle } from "../../../components/headerTitle";
import { useNavigate, useParams } from "react-router-dom";
import http from "../../../services/http";
const { Text } = Typography;

// STATUS
const options_status = [
  { value: 0, label: "Inativo" },
  { value: 1, label: "Ativo" },
];

export const TreinamentosCadAlternativas = () => {
  const { id_grupo, id_formulario, id_curso, id_modulo, id_questao } = useParams();
  const navigate = useNavigate();
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);
  const [dados, setDados] = useState([]);

  const [showModal, setShowModal] = useState(false);
  const [modal, contextHolder] = Modal.useModal();

  // ID ALTERAÇÃO
  const [idAlt, setIdAlt] = useState(0);
  const [search, setSearch] = useState("");

  // DADOS
  const [formulario, setQuestao] = useState({});

  useEffect(() => {
    if (id_questao > 0) {
      carregarQuestao(id_questao);
      listarAlternativas(id_questao);
    }
  }, [id_questao]);

  // CARREGAR
  const carregarQuestao = async (id) => {
    if (!id) return;
    setLoading(true);
    const api = await http("get", `v1/treinamentos_questoes/carregar/${id}`, []);
    if (api.statusCode === 200) {
      const response = api?.response?.data;
      setQuestao(response);
    } else {
      message.error(api.response.message);
    }
    setLoading(false);
  };

  // LISTAR
  const listarAlternativas = async (id) => {
    if (!id) return;
    setLoading(true);
    const api = await http("get", `v1/treinamentos_alternativas/listar/${id}`, []);
    if (api.statusCode === 200) {
      setDados(api.response.data);
    } else {
      navigate("/treinamentos/grupos");
      message.error(api.response.message);
    }
    setLoading(false);
  };

  // CADASTRAR
  const cadastrarAlternativa = async (formulario) => {
    setLoading(true);
    const api = await http("post", `v1/treinamentos_alternativas/adicionar`, formulario);
    if (api.statusCode === 200) {
      message.success("Registro cadastrado com sucesso!");
      setShowModal(false);
      resetForm();
      listarAlternativas(id_questao);
    } else {
      message.error(api.response.message);
    }
    setLoading(false);
  };

  // ALTERAR
  const alterarAlternativa = async (formulario) => {
    setLoading(true);
    const api = await http("post", `v1/treinamentos_alternativas/alterar`, formulario);
    if (api.statusCode === 200) {
      message.success("Registro alterado com sucesso!");
      setShowModal(false);
      resetForm();
      listarAlternativas(id_questao);
    } else {
      message.error(api.response.message);
    }
    setLoading(false);
  };

  // CARREGAR
  const carregarAlternativa = async (id) => {
    if (!id) return;
    setLoading(true);
    const api = await http("get", `v1/treinamentos_alternativas/carregar/${id}`, []);

    if (api.statusCode === 200) {
      const response = api?.response?.data;

      setShowModal(true);
      resetForm();
      form.setFieldsValue({
        descricao: response.descricao,
        status: response.status,
      });
      setIdAlt(api.response.data.id);
    } else {
      message.error(api.response.message);
    }
    setLoading(false);
  };

  // DELETAR
  const deletarAlternativa = async (id) => {
    setLoading(true);
    const api = await http("post", `v1/treinamentos_alternativas/deletar`, { id: id });
    if (api.statusCode === 200) {
      message.success("Registro deletado com sucesso!");
      listarAlternativas(id_questao);
    } else {
      message.error(api.response.message);
    }
    setLoading(false);
  };

  // CORRETA
  const definirCorreta = async (id, id_treinamentos_cad_questoes) => {
    setLoading(true);
    const api = await http("post", `v1/treinamentos_alternativas/definir_correta`, {
      id: id,
      id_treinamentos_cad_questoes: id_treinamentos_cad_questoes,
    });
    if (api.statusCode === 200) {
      listarAlternativas(id_questao);
    } else {
      message.error(api.response.message);
    }
    setLoading(false);
  };

  // RESET FORM
  const resetForm = () => {
    form.resetFields();
    setIdAlt(0);
  };

  // COLUNAS TABLE
  const columns = [
    {
      title: "Descrição",
      dataIndex: "descricao",
      sorter: (a, b) => a.descricao?.localeCompare(b.descricao),
    },
    {
      title: "Status",
      dataIndex: "status",
      render: (_, e) => (e.status === 1 ? "Ativo" : "Inativo"),
      sorter: (a, b) => (a.status === 1 ? "Ativo" : "Inativo")?.localeCompare(b.status === 1 ? "Ativo" : "Inativo"),
    },
    {
      title: "Correta",
      dataIndex: "correta",
      width: 100,
      render: (_, e) =>
        e.correta === 0 ? (
          <Button
            onClick={() => definirCorreta(e?.id, id_questao)}
            type="link"
            icon={<CloseCircleOutlined style={{ fontSize: 20, color: "#ff5757" }} />}
          />
        ) : (
          <Button disabled type="link" icon={<CheckCircleOutlined style={{ fontSize: 20, color: "#60b565" }} />} />
        ),
    },
    {
      title: "Ações",
      width: 150,
      render: (_, e) => (
        <Space.Compact>
          <Tooltip title="Editar">
            <Button loading={loading} onClick={() => carregarAlternativa(e.id)} icon={<EditOutlined />} />
          </Tooltip>
          <Tooltip title="Excluir">
            <Button
              loading={loading}
              icon={<DeleteOutlined />}
              onClick={() => {
                modal.confirm({
                  title: "Deseja deletar este registro?",
                  okText: "Sim",
                  cancelText: "Cancelar",
                  onOk() {
                    deletarAlternativa(e.id);
                  },
                });
              }}
            />
          </Tooltip>
        </Space.Compact>
      ),
      dataIndex: "acoes",
    },
  ];

  // SUBMIT FORM
  const onSubmit = (formulario) => {
    formulario.id_treinamentos_cad_questoes = id_questao;

    if (idAlt > 0) {
      formulario.id = idAlt;
      alterarAlternativa(formulario);
    } else {
      cadastrarAlternativa(formulario);
    }
  };

  // PESQUISAR
  const handleFilter = (pesquisar) => {
    let filteredData = dados?.filter((val) => val.descricao?.toLowerCase().includes(pesquisar.toLowerCase()));
    return filteredData;
  };

  const dadosFilter = dados?.length > 0 ? handleFilter(search) : [];

  // FORMULÁRIO
  const modalAlternativa = () => {
    return (
      <Modal
        title={
          <Text style={{ fontSize: 20 }}>
            <EditOutlined /> {idAlt > 0 ? "Editar" : "Adicionar"} Alternativa
          </Text>
        }
        open={showModal}
        onOk={() => form.submit()}
        okText="Salvar"
        width={1200}
        okButtonProps={{ size: "large", loading: loading }}
        cancelButtonProps={{ size: "large", loading: loading }}
        onCancel={() => {
          setShowModal(false);
          resetForm();
        }}>
        <Form form={form} onFinish={onSubmit} layout="vertical" autoComplete="off">
          <Row gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }}>
            <Col className="gutter-row" xs={24} sm={24} md={12} lg={12} xl={12}>
              <Form.Item
                name="descricao"
                label="Descrição"
                rules={[{ required: true, message: "Digite a descrição!" }]}>
                <Input size="large" disabled={loading} placeholder="Informe a descrição" />
              </Form.Item>
            </Col>

            <Col className="gutter-row" xs={24} sm={24} md={12} lg={12} xl={12}>
              <Form.Item name="status" label="Status" rules={[{ required: true, message: "Selecione o status!" }]}>
                <Select
                  size="large"
                  placeholder="Selecione o status"
                  disabled={loading}
                  style={{ width: "100%" }}
                  options={options_status}
                />
              </Form.Item>
            </Col>
          </Row>
        </Form>
      </Modal>
    );
  };

  return (
    <Row align="middle" justify="center" className="content-row">
      {modalAlternativa()}
      <Col span={24} align="middle" justify="center">
        <Col xs={24} sm={24} md={22} lg={22} xl={20} xxl={16} align="left">
          <div className="content-item">
            <HeaderPage
              title="Treinamentos & Desenvolvimento"
              onClickBack={() =>
                navigate(
                  `/treinamentos/grupos/cursos/${id_grupo}/modulos/${id_curso}/formularios/${id_modulo}/questoes/${id_formulario}`
                )
              }
            />
            <HeaderTitle
              title="Alternativas"
              subtitle={
                <Text italic>
                  <OrderedListOutlined /> {formulario?.descricao ?? ""}
                </Text>
              }
              icon={<UnorderedListOutlined />}
              loading={loading}
            />
            <Divider />
            <Card bordered={false} bodyStyle={{ padding: "3%" }}>
              <Space wrap>
                <Input
                  size="middle"
                  maxLength={100}
                  prefix={<SearchOutlined />}
                  className="input"
                  value={search}
                  onChange={(e) => setSearch(e.target.value)}
                  placeholder="Pesquisar..."
                  allowClear
                />
                <Tooltip title="Adicionar Registro">
                  <Button
                    type="primary"
                    icon={<PlusOutlined />}
                    onClick={() => {
                      setShowModal(true);
                      resetForm();
                    }}
                    loading={loading}>
                    Novo
                  </Button>
                </Tooltip>
              </Space>

              <Divider />

              <Table
                rowKey="id"
                loading={loading}
                scroll={{ x: 700 }}
                columns={columns}
                dataSource={dadosFilter}
                size="small"
              />
            </Card>
          </div>
        </Col>
      </Col>
      {contextHolder}
    </Row>
  );
};
